import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Events, } from 'ionic-angular';

const DELIVERSTATUS = 2;
const RECEIVESTATUS = 3;
const NO_INDEX = -1;

@Component({
  selector: 'button-renderer',
  templateUrl: 'button-renderer.html'
})

export class ButtonRendererComponent implements ICellRendererAngularComp {

  text: string;
  cellValue: any;
  label: string;
  actionStatus: any;
  deliveredStatus: any;
  receiveStatus: any;
  status: any;


  constructor(public events: Events) {

  }

  agInit(params: any): void {
    this.cellValue = params;
    this.label = this.cellValue.label || null;
    let statusIdx = Object.keys(params.data).findIndex(elem => elem.toLowerCase() == 'Status'.toLowerCase());
    if (statusIdx != NO_INDEX) {
      const gridData = {};
      for (const [key, value] of Object.entries(params.data)) {
        gridData[key.toLowerCase()] = value;
      }
      if (gridData['status']) {
        if (gridData['status'] == DELIVERSTATUS) {
          this.deliveredStatus = 'DeliveredStatus';
        } else if (gridData['status'] == RECEIVESTATUS) {
          this.receiveStatus = 'ReceiveStatus';
        }
      }
    }
  }

  refresh(params?: any): boolean {
    this.cellValue = params;
    this.agInit(params);
    return true;
  }

  onClick(e) {

    if (this.cellValue.onClick instanceof Function) {

      const params = {
        event: e,
        rowData: this.cellValue.node.data,
        type: 'update',
        rowIndex: this.cellValue.rowIndex

      }
      this.cellValue.onClick(params);
    }
  }
  onClickSlide(e) {

    if (this.cellValue.onClick instanceof Function) {

      const params = {
        event: e,
        rowData: this.cellValue.node.data,
        rowIndex: this.cellValue.rowIndex

      }
      this.cellValue.onClick(params);
    }
  }
  onClickClear(e) {

    if (this.cellValue.onClick instanceof Function) {

      const params = {
        event: e,
        rowData: this.cellValue.node.data,
        type: 'clear',
        rowIndex: this.cellValue.rowIndex

      }
      this.cellValue.onClick(params);
    }
  }



}



// WEBPACK FOOTER //
// ./src/components/button-renderer/button-renderer.ts